import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
// import { MessageService } from '../../../app/core/web-socket/message.service';
import { AfterViewChecked, Component, Renderer2, ElementRef, ViewChild, ChangeDetectorRef, HostListener, OnInit, Inject } from '@angular/core';
import { PreviousDataService } from 'src/app/core/services/previous-gyan/previous-data.service';
import { faSignIn, faKey, faSync, faFileExport, faTrash, faLock, faSignOut, faPlus, faMinus, faFolder, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { LoginComponent } from '../login/login.component';
import { SignupComponent } from '../signup/signup.component';
import { GetproComponent } from '../getpro/getpro.component';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ArticleService } from 'src/app/core/services/articles/article.service';
import { AuthenticationResult, InteractionType, PopupRequest, PromptValue, RedirectRequest } from '@azure/msal-browser';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'src/app/core/services/local-storage/local-storage.service';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { SubmitgyanService } from 'src/app/core/services/submit-gyan/submitgyan.service';
import { BreadcrumbComponent } from '../gyan-organisation/breadcrumb/breadcrumb.component';
import { BreadcrumbService } from '../gyan-organisation/breadcrumb/breadcrumb.service';
import { MoveBreadcrumbService } from '../gyan-organisation/moveBreadcrumb/moveBreadcrumb.service';
import { Subscription } from 'rxjs';
import { Tooltip } from 'bootstrap';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ResizeEvent } from 'angular-resizable-element';
import { Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { b2cPolicies } from 'src/app/config/auth-config';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthService } from './../../core/services/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    styleUrls: ['./admin-dashboard.component.scss'],
    animations: [
        trigger('expandCollapse1', [
            state(
                'expanded',
                style({
                    width: '16.66%',
                }),
            ),
            state(
                'collapsed',
                style({
                    width: '4%',
                }),
            ),
            transition('expanded => collapsed', [animate('0.1s')]),
            transition('collapsed => expanded', [animate('0.1s')]),
        ]),
        trigger('expandCollapse2', [
            state(
                'expanded',
                style({
                    width: '83.3%',
                }),
            ),
            state(
                'collapsed',
                style({
                    width: '96%',
                }),
            ),
            transition('expanded => collapsed', [animate('0.1s')]),
            transition('collapsed => expanded', [animate('0.1s')]),
        ]),
    ],
})
export class AdminDashboardComponent implements OnInit {
    currentRoute: string = '';
    componentName: any;
    isrepodropdownopen = true;
    isgks = false;
    ismks = false;
    isUsersdropdownopen = true;
    isAcessdropdownopen = true;
    isRepodropdownopen = true;
    isAccessManagmentdropdownopen = false;
    isVerified: boolean = true;
    faLock = faLock;
    faSignOut = faSignOut;
    faBars = faBars;
    faEdit = faEdit;
    faEllipsisV = faEllipsisV;
    faEarthAsia = faEarthAsia;
    faFileExport = faFileExport;
    faSearch = faSearch;
    faSync = faSync;
    isHideTab = false;
    faTrash = faTrash;
    showOptionsBox = false;
    isPreviousListOpen = false; // Add this variable to track the state of previous list
    faGoogle = faGoogle;
    faSignIn = faSignIn;
    faKey = faKey;
    faPlus = faPlus;
    faMinus = faMinus;
    faFolder = faFolder;
    faCaretRight = faCaretRight;
    faCaretDown = faCaretDown;
    isExpanded: { [key: string]: boolean } = { all: true };
    folderId: any;
    toggleFolderId: any;
    sortType = 'date';
    sortBy = 'desc';
    isBlack: boolean = false;
    menuStates: { [key: string]: boolean } = {
        'user-management': false,
        'access-management': false,
        'gyan-settings': false,
        'repository-settings': false,
    };
    selectedList = [
        {
            name: 'selectSources',
            isBlack: false,
        },
        {
            name: 'previousSearch',
            isBlack: false,
        },
    ];
    pageSize: number = 0;
    pageSizeAQ: number = 0;
    previousGyanList: any = {
        eachGyanResponseList: [],
    };
    isPreviousSearchOpen: boolean = false;
    isUsersOpen: boolean = false;
    isUserGroupOpen: boolean = false;
    isClientsOpen: boolean = false;
    isAdvanceQueryOpen: boolean = false;

    selecteditem: any = null;
    showBreadcrumb = true;

    hoverState: { [key: string]: boolean } = {};

    @ViewChild(LoginComponent) logInModal!: LoginComponent;
    @ViewChild(SignupComponent) signUpModal!: SignupComponent;
    @ViewChild('optionsBox') optionsBox!: ElementRef;
    @ViewChild('scrollTopDiv') scrollTopDiv: ElementRef | undefined;
    isMobile: boolean = false;
    removeDisabled: boolean = false;
    isLoading: boolean = true;
    signInUser: boolean = false;

    deleteMessage = '';
    private modalRef: NgbModalRef | undefined;
    public style: object = {};
    resizeEndFlag = false;
    isPreviousSearchonFlag: boolean = false;
    showAndHideSubtopicsrepo = false;

    createUserGroupForClient: Subscription;

    constructor(
        private route: ActivatedRoute,
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private router: Router,
        private previousDataService: PreviousDataService,
        private cdr: ChangeDetectorRef,
        private authService: AuthService,
        private toastrService: ToastrService,
        private localStorageService: LocalStorageService,
        private commonServiceService: CommonServiceService,
        private breadcrumbService: BreadcrumbService,
        private moveBreadcrumbService: MoveBreadcrumbService,
        private modalService: NgbModal,
        private cookieService: CookieService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private msalService: MsalService,
    ) {
        this.checkWidth();
        this.createUserGroupForClient = this.commonServiceService.createUserGroupForClient$.subscribe((data) => {
            if (data?.createnew) {
                console.log('the value for createUserGroupForClient is', data.data.name);
                this.isUserGroupMenu = true;
                this.isClientMenu = false;
                this.isUserMenu = false;
            }
        });
    }

    toggleNode(event: any): void {
        if (event !== null) {
            event.stopPropagation(); // Prevents the event from bubbling up and triggering other handlers.
        }
    }

    onResizeEnd(event: ResizeEvent): void {
        this.resizeEndFlag = true;
        this.style = {
            width: `${event.rectangle.width}px`,
            borderRight: `6px solid #F6F6F6`,
        };
        if (event.edges.right == 0 || (typeof event.edges.right === 'number' && event.edges.right <= 0)) {
            this.resetSize();
            this.resizeEndFlag = false;
        }
    }

    resetSize() {
        this.style = {};
    }

    isVerifiedUser() {
        return this.isVerified;
    }
    parentStr: string = '';
    childStr: string = '';
    aryUserMng: any = ['user', 'client', 'user-group'];
    isClientMenu: boolean = true;
    isUserGroupMenu: boolean = false;
    isUserMenu: boolean = false;

    isAccessMenu: boolean = false;
    isAdminRoute = true;

    // ngOnInit() {
    //     this.isAdminRoute = this.router.url.startsWith('/admin');
    //     console.log('I am getting called after resfresh', this.router.url);
    //     if (this.router.url == '/admin/client') {
    //         this.displaySubManagements('user-management');
    //     }
    //     if (this.router.url == '/admin/user-group') {
    //         this.isUserGroupMenu = true;
    //         this.isClientMenu = false;
    //         this.isUserMenu = false;
    //         this.isAccessMenu = false;
    //         this.ismks = false;
    //         this.isgks = false;
    //         this.displaySubManagements('user-management');
    //     } else if (this.router.url == '/admin/user') {
    //         this.isUserGroupMenu = false;
    //         this.isClientMenu = false;
    //         this.isUserMenu = true;
    //         this.isAccessMenu = false;
    //         this.ismks = false;
    //         this.isgks = false;
    //         this.displaySubManagements('user-management');
    //     } else if (this.router.url == '/admin/access') {
    //         this.isUserGroupMenu = false;
    //         this.isClientMenu = false;
    //         this.isUserMenu = false;
    //         this.isAccessMenu = true;
    //         this.ismks = false;
    //         this.isgks = false;
    //         this.displaySubManagements('access-management');
    //     } else if (this.router.url == '/admin/knowledge-store') {
    //         this.isUserGroupMenu = false;
    //         this.isClientMenu = false;
    //         this.isUserMenu = false;
    //         this.isAccessMenu = false;
    //         this.showAndHideSubtopicsrepo = true;
    //         //open repo settings
    //         this.isgks = true;
    //         this.ismks = false;
    //         this.displaySubManagements('repository-settings');
    //     } else if (this.router.url == '/admin/my-content') {
    //         this.isUserGroupMenu = false;
    //         this.isClientMenu = false;
    //         this.isUserMenu = false;
    //         this.isAccessMenu = false;
    //         this.showAndHideSubtopicsrepo = true;
    //         //open repo settings
    //         this.isgks = false;
    //         this.ismks = true;
    //         this.displaySubManagements('repository-settings');
    //     }

    //     if (!this.isSignInUser()) {
    //         //this.msalService.logout();
    //         this.azureLogin();
    //     } else {
    //         console.log('User already signed in');
    //     }

    //     this.msalService.handleRedirectObservable().subscribe({
    //         next: (result) => {
    //             if (result) {
    //                 console.log('Login successful:', result.account);
    //             }
    //         },
    //         error: (error) => {
    //             console.error('Error during login:', error);
    //         },
    //     });
    //     this.localStorageService.setItem('rootGyanId', '');
    //     this.closeMenuOnOutsideClick();
    //     this.isVerified = this.authService.getIsVerified() === 'true';
    //     // setTimeout(() => {
    //     this.isLoading = false;
    //     // }, 2000);
    //     console.log('isHideTab', this.isHideTab);
    // }

    // sagar
    ngOnInit() {
        this.isAdminRoute = this.router.url.startsWith('/admin');

        // Handle initial route and state sync
        this.handleRouteChange(this.router.url);

        // Listen for back/forward navigation to sync UI state
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.handleRouteChange(event.urlAfterRedirects);
            }
        });

        // this.checkUserSignIn();
        this.localStorageService.setItem('rootGyanId', '');
        this.closeMenuOnOutsideClick();
        this.isVerified = this.authService.getIsVerified() === 'true';
        this.isLoading = false;
    }

    private handleRouteChange(url: string) {
        this.resetMenuStates();

        switch (url) {
            case '/admin/client':
                this.isClientMenu = true;
                this.isUserGroupMenu = false;
                this.isUserMenu = false;
                this.displaySubManagements('user-management');
                break;
            case '/admin/user-group':
                this.isUserGroupMenu = true;
                this.isClientMenu = false;
                this.isUserMenu = true;
                this.displaySubManagements('user-management');
                break;
            case '/admin/user':
                this.isUserMenu = true;
                this.isClientMenu = false;
                this.isUserGroupMenu = false;
                this.displaySubManagements('user-management');
                break;
            case '/admin/access':
                this.isAccessMenu = true;
                this.displaySubManagements('access-management');
                break;
            case '/admin/knowledge-store':
                this.isgks = true;
                this.ismks = false;
                this.showAndHideSubtopicsrepo = true;
                this.displaySubManagements('repository-settings');
                break;
            case '/admin/my-content':
                this.ismks = true;
                this.isgks = false;
                this.showAndHideSubtopicsrepo = true;
                this.displaySubManagements('repository-settings');
                break;
            default:
                console.warn('Unhandled route:', url);
                break;
        }
    }

    private resetMenuStates() {
        this.isUserGroupMenu = false;
        this.isClientMenu = false;
        this.isUserMenu = false;
        this.isAccessMenu = false;
        this.ismks = false;
        this.isgks = false;
        this.showAndHideSubtopicsrepo = false;
    }

    // sagar

    onButtonHover(event: MouseEvent) {
        console.log('Hovered:', event);
        // Implement your logic here
    }

    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    hideTab(event?: Event) {
        if (event) {
            event.stopPropagation();
        }
        console.log('hideTab called');
        this.isHideTab = !this.isHideTab;
        console.log(this.isHideTab);
    }

    openLogInModal(): void {
        this.logInModal.openLogInModal();
    }
    openSignUpModal(): void {
        this.signUpModal.openSignUpModal();
    }
    UserSignIn() {
        console.log('Signed In');
    }
    isSignInUser() {
        //add a local variable and set it to - advanced
        if (this.authService.isSignInUser()) this.signInUser = true;
        else this.signInUser = false;
        return this.authService.isSignInUser();
    }
    showPopover: boolean = false;

    showTooltip(event: MouseEvent): void {
        const tooltip = (event.target as HTMLElement).querySelector('.custom-tooltip') as HTMLElement;
        if (tooltip) {
            tooltip.style.visibility = 'visible';
            tooltip.style.opacity = '1';
        }
    }

    hideTooltip(event: MouseEvent): void {
        const tooltip = (event.target as HTMLElement).querySelector('.custom-tooltip') as HTMLElement;
        if (tooltip) {
            tooltip.style.visibility = 'hidden';
            tooltip.style.opacity = '0';
        }
    }

    getSignInUser() {
        return this.authService.getSignInUser();
    }
    logout() {
        this.router.navigate(['/']).then((x: any) => {
            this.authService.logout();
        });
    }
    deleteCookie(name: string) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
    resetPassword() {
        this.authService.forgotPassword();
    }
    splitText(title: string) {
        if (title !== null && title !== undefined && title.length > 30) {
            title = title.slice(0, 30) + '..';
        }
        return title;
    }
    menuOpen: boolean = false;
    closeOption() {
        if (this.menuOpen) {
            const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
            if (!optionsMenus) return; // Check if optionsBoxes is null
            // Hide all other open options boxes
            optionsMenus.forEach((box) => {
                //if (box !== currentTarget.nextElementSibling) {
                box.classList.remove('comment-box-menu-icon-select');
                //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
                // }
            });

            const optionsBoxes = document.querySelectorAll('.options-box') as NodeListOf<HTMLElement>;
            if (!optionsBoxes) return; // Check if optionsBoxes is null
            optionsBoxes.forEach((box) => {
                box.classList.remove('show');
            });
            this.menuOpen = false;
        }
    }
    onButtonClick(event: MouseEvent) {
        event.stopImmediatePropagation();
        this.menuOpen = true;

        const currentTarget = event.currentTarget as HTMLElement;
        console.log(' >> currentTarget << ');
        console.log(currentTarget);
        console.log(' >> currentTarget << ');
        const x = event.clientX;
        const y = event.clientY;
        console.log(' >> currentTarget >> x' + x);
        console.log(' >> currentTarget >> y' + y);
        if (!currentTarget) return; // Check if currentTarget is null
        const optionsBoxes = document.querySelectorAll('.options-box') as NodeListOf<HTMLElement>;
        if (!optionsBoxes) return; // Check if optionsBoxes is null
        // Hide all other open options boxes
        optionsBoxes.forEach((box) => {
            if (box !== currentTarget.nextElementSibling) {
                box.classList.remove('show');
                //box.style.setProperty('left',y.toString());
                //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
            }
        });

        const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
        if (!optionsMenus) return; // Check if optionsBoxes is null
        // Hide all other open options boxes
        optionsMenus.forEach((box) => {
            //if (box !== currentTarget.nextElementSibling) {
            box.classList.remove('comment-box-menu-icon-select');
            //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
            // }
        });

        const optionsBox = currentTarget.nextElementSibling;
        if (!optionsBox) return; // Check if optionsBox is null
        optionsBox.classList.toggle('show');
        const rect = (event.target as HTMLElement).getBoundingClientRect();
        (optionsBox as HTMLElement).style.setProperty('top', (rect.bottom + window.scrollY).toString() + 'px');
        //(optionsBox as HTMLElement).style.setProperty('left', ((optionsBox as HTMLElement).getBoundingClientRect().left + window.scrollX).toString() + 'px');

        currentTarget.classList.add('comment-box-menu-icon-select');
        if (optionsBox.classList.contains('show')) {
            this.globalClickListener = this.renderer.listen('document', 'click', (clickEvent: MouseEvent) => {
                if (!optionsBox.contains(clickEvent.target as HTMLElement) && !currentTarget.contains(clickEvent.target as HTMLElement)) {
                    const optionsMenus = document.querySelectorAll('.comment-box-menu-icon') as NodeListOf<HTMLElement>;
                    if (!optionsMenus) return; // Check if optionsBoxes is null
                    // Hide all other open options boxes
                    optionsMenus.forEach((box) => {
                        //if (box !== currentTarget.nextElementSibling) {
                        box.classList.remove('comment-box-menu-icon-select');
                        //box.previousElementSibling.classList.remove('comment-box-menu-icon-select');
                        // }
                    });

                    optionsBox.classList.remove('show');
                    this.globalClickListener(); // Remove the listener once it's no longer needed
                }
            });
        } else {
            if (this.globalClickListener) {
                this.globalClickListener();
            }
        }
    }
    menuTrigger: any;
    @ViewChild('specificDivBox') specificDivBox!: ElementRef;
    @ViewChild('specificDivBoxControl') specificDivBoxControl!: ElementRef;
    private globalClickListener!: () => void;

    closeMenuOnOutsideClick() {
        console.log('closeMenuOnOutsideClick called');
        this.renderer.listen('window', 'click', (event: Event) => {
            if (
                this.isMobile &&
                this.isHideTab &&
                !((this.specificDivBox && this.specificDivBox.nativeElement.contains(event.target)) || this.specificDivBoxControl.nativeElement.contains(event.target))
            ) {
                // Trigger your event here
                this.hideTab();
            }
            if (this.menuOpen && !this.elementRef.nativeElement.contains(event.target)) {
                this.closeOption();
                this.menuOpen = false;
                if (this.globalClickListener) {
                    this.globalClickListener();
                }
            }
        });
    }
    toggleColor(itemName: any) {
        const selectedItem = this.selectedList.find((item) => item.name === itemName);
        if (selectedItem) {
            selectedItem.isBlack = !selectedItem.isBlack;
        }
        this.selectedList.forEach((item) => {
            if (item.name !== itemName) {
                item.isBlack = false;
            }
        });
    }
    isItemBlack(itemName: string) {
        const selectedItem = this.selectedList.find((item) => item.name === itemName);
        return selectedItem ? selectedItem.isBlack : false;
    }
    toggleHover(itemName: string, state: boolean) {
        this.hoverState[itemName] = state;
    }

    checkWidth() {
        const width = window.innerWidth;
        console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    gotoDashboardhome() {
        this.localStorageService.setItem('rootGyanId', '');
    }

    toggleUsers() {
        console.log('toggleUsers called');
        this.clickClientMenu();
        this.hideTab();
    }
    toggleAcess() {
        this.clickAccessMenu();
        this.hideTab();
    }

    toggleRepo() {
        this.clickMKSMenu();
        this.hideTab();
    }

    showAndHideSubtopics = true;

    // sagar

    displaySubManagements(menuId: string) {
        // Close all other menus except the one being clicked
        Object.keys(this.menuStates).forEach((menu) => {
            this.menuStates[menu] = menu === menuId;
        });

        // Additional routing logic for different menu IDs
        switch (menuId) {
            case 'repository-settings':
                this.router.navigate(['/admin', this.isgks ? 'knowledge-store' : 'my-content']);
                this.updateMenuStates(false, false, false, true, false, false, false, this.isgks, this.ismks);
                break;
            case 'user-management':
                let targetPath = '';

                if (this.isUserGroupMenu) {
                    targetPath = 'user-group';
                    this.isUserMenu = false;
                    this.isClientMenu = false;
                } else if (this.isUserMenu) {
                    targetPath = 'user';
                    this.isUserGroupMenu = false;
                    this.isClientMenu = false;
                } else {
                    targetPath = 'client';
                }
                this.router.navigate(['/admin', this.isUserMenu ? 'user' : this.isUserGroupMenu ? 'user-group' : 'client']);
                this.updateMenuStates(true, false, this.isUserMenu, false, this.isClientMenu, this.isUserGroupMenu, false, false, false);
                break;
            case 'access-management':
                this.router.navigate(['/admin', 'access']);
                this.updateMenuStates(false, true, false, false, false, false, true, false, false);
                break;
        }
    }

    updateMenuStates(usermanagment: boolean, access: boolean, users: boolean, repo: boolean, client: boolean, userGroup: boolean, accessMenu: boolean, gks: boolean, mks: boolean) {
        this.isUsersdropdownopen = usermanagment;
        this.isAcessdropdownopen = access;
        this.isUserMenu = users;
        this.isRepodropdownopen = repo;
        this.isClientMenu = client;
        this.isUserGroupMenu = userGroup;
        this.isAccessMenu = accessMenu;
        this.isgks = gks;
        this.ismks = mks;
    }

    clickClientMenu() {
        this.isClientMenu = true;
        this.isUserGroupMenu = false;
        this.isUserMenu = false;
        this.displaySubManagements('user-management');
        this.router.navigate(['/admin', 'client']);
    }

    // clickUserMenu() {
    //     this.displaySubManagements('user-management');
    //     this.router.navigate(['/admin', 'user']);
    // }

    // clickuserGroupMenu() {
    //     this.displaySubManagements('user-management');
    //     this.router.navigate(['/admin', 'user-group']);
    //     this.commonServiceService.setCreateUsergroupforClient({ createnew: false });
    // }

    clickMKSMenu() {
        this.isgks = false;
        this.ismks = true;
        this.displaySubManagements('repository-settings');
    }

    clickGKSMenu() {
        this.isgks = true;
        this.ismks = false;
        this.displaySubManagements('repository-settings');
    }

    clickAccessMenu() {
        this.displaySubManagements('access-management');
    }

    clickuserGroupMenu() {
        this.isClientMenu = false;
        this.isUserGroupMenu = true;
        this.isUserMenu = false;
        this.displaySubManagements('user-management');
        this.router.navigate(['/admin', 'user-group']);
        // this.commonServiceService.setCreateUsergroupforClient({ createnew: false });
    }

    clickUserMenu() {
        this.isClientMenu = false;
        this.isUserGroupMenu = false;
        this.isUserMenu = true;
        this.displaySubManagements('user-management');
        this.router.navigate(['/admin', 'user']);
    }

    // sagar

    // displaySubManagements(menuId: string) {
    //     // Close all other menus except the one being clicked
    //     Object.keys(this.menuStates).forEach((menu) => {
    //         if (menu !== menuId) {
    //             this.menuStates[menu] = false;
    //         }
    //     });

    //     // Only toggle the clicked menu if it's not already open
    //     if (!this.menuStates[menuId]) {
    //         this.menuStates[menuId] = true;
    //     }

    //     // Additional logic for 'repository-settings'
    //     if (menuId === 'repository-settings') {
    //         this.router.navigate(['/admin', 'my-content']);
    //         this.isAcessdropdownopen = false;
    //         this.isUsersdropdownopen = false;
    //         this.isRepodropdownopen = true;
    //         this.isUserGroupMenu = false;
    //         this.isUserMenu = false;
    //         this.isClientMenu = false;
    //         this.isgks = false;
    //         this.ismks = true;
    //         this.isAccessMenu = false;
    //     } else if (menuId === 'user-management' && this.menuStates['user-management']) {
    //         this.router.navigate(['/admin', 'client']);
    //         this.isAcessdropdownopen = false;
    //         this.isUsersdropdownopen = true;
    //         this.isRepodropdownopen = false;
    //         this.isUserGroupMenu = false;
    //         this.isUserMenu = false;
    //         this.isClientMenu = true;
    //         this.isgks = false;
    //         this.ismks = false;
    //         this.isAccessMenu = false;
    //     } else if (menuId === 'access-management' && this.menuStates['access-management']) {
    //         this.router.navigate(['/admin', 'access']);
    //         this.isAcessdropdownopen = true;
    //         this.isUsersdropdownopen = false;
    //         this.isRepodropdownopen = false;
    //         this.isUserGroupMenu = false;
    //         this.isUserMenu = false;
    //         this.isClientMenu = false;
    //         this.isgks = false;
    //         this.ismks = false;
    //         this.isAccessMenu = true;
    //     }
    // }

    // clickClientMenu() {
    //     this.isAcessdropdownopen = false;
    //     this.isRepodropdownopen = false;
    //     this.isUsersdropdownopen = true;
    //     if (this.isAccessManagmentdropdownopen) {
    //         this.isAccessManagmentdropdownopen = false;
    //     }

    //     this.menuStates = {};
    //     this.displaySubManagements('user-management');
    //     if (this.isMobile) this.hideTab();
    //     this.router.navigate(['/admin', 'client']);
    //     this.isgks = false;
    //     this.ismks = false;
    //     this.isUserMenu = false;
    //     this.isUserGroupMenu = false;
    //     this.isClientMenu = true;
    //     this.isAccessMenu = false;
    // }

    // clickUserMenu() {
    //     this.isAcessdropdownopen = false;
    //     this.isRepodropdownopen = false;
    //     this.isUsersdropdownopen = true;
    //     this.menuStates = {};
    //     this.displaySubManagements('user-management');
    //     if (this.isMobile) this.hideTab();
    //     this.router.navigate(['/admin', 'user']);
    //     this.isgks = false;
    //     this.ismks = false;
    //     this.isUserGroupMenu = false;
    //     this.isUserMenu = true;
    //     this.isClientMenu = false;
    //     this.isAccessMenu = false;
    // }

    // clickuserGroupMenu() {
    //     this.isAcessdropdownopen = false;
    //     this.isRepodropdownopen = false;
    //     this.isUsersdropdownopen = true;
    //     this.menuStates = {};
    //     this.displaySubManagements('user-management');
    //     if (this.isMobile) this.hideTab();
    //     this.router.navigate(['/admin', 'user-group']);
    //     this.isgks = false;
    //     this.ismks = false;
    //     this.isUserGroupMenu = true;
    //     this.isUserMenu = false;
    //     this.isClientMenu = false;
    //     this.isAccessMenu = false;
    //     const data = {
    //         createnew: false,
    //     };
    //     //call a subject to know that this is for a client and usergroup creation
    //     this.commonServiceService.setCreateUsergroupforClient(data);
    // }

    // // clickAccessMenu() {
    // //     this.isAccessMenu = true;
    // //     this.isUserGroupMenu = false;
    // //     this.isUserMenu = false;
    // //     this.isClientMenu = false;
    // //     this.menuStates = {};
    // //     this.displaySubManagements('access-management');
    // //     if (this.isMobile) this.hideTab();
    // //     this.router.navigate(['/admin', 'access']);
    // // }

    // clickMKSMenu() {
    //     this.isAcessdropdownopen = false;
    //     this.isUsersdropdownopen = false;
    //     this.isRepodropdownopen = true;
    //     this.menuStates = {};
    //     this.displaySubManagements('repository-settings');
    //     if (this.isMobile) this.hideTab();
    //     this.router.navigate(['/admin', 'my-content']);
    //     this.isUserGroupMenu = false;
    //     this.isUserMenu = false;
    //     this.isClientMenu = false;
    //     this.isgks = false;
    //     this.ismks = true;
    // }

    // clickGKSMenu() {
    //     this.isAcessdropdownopen = false;
    //     this.isUsersdropdownopen = false;
    //     this.isRepodropdownopen = true;
    //     this.menuStates = {};
    //     this.displaySubManagements('repository-settings');
    //     if (this.isMobile) this.hideTab();
    //     this.router.navigate(['/admin', 'knowledge-store']);
    //     this.isUserGroupMenu = false;
    //     this.isUserMenu = false;
    //     this.isClientMenu = false;
    //     this.isgks = true;
    //     this.ismks = false;
    // }

    // clickAccessMenu() {
    //     this.isAcessdropdownopen = true;
    //     this.isRepodropdownopen = false;
    //     this.isUsersdropdownopen = false;
    //     this.menuStates = {};
    //     this.displaySubManagements('acess-management');
    //     if (this.isMobile) this.hideTab();
    //     this.router.navigate(['/admin', 'access']);
    //     this.isAccessMenu = true;
    //     this.isUserGroupMenu = false;
    //     this.isUserMenu = false;
    //     this.isClientMenu = false;
    //     this.isgks = false;
    //     this.ismks = false;
    // }

    toggleUserGroup() {
        this.isAccessManagmentdropdownopen = !this.isAccessManagmentdropdownopen;
        // Optionally close the "Users" dropdown if it's open
        if (this.isUsersdropdownopen) {
            this.isUsersdropdownopen = false;
        }
    }
    azureLogin() {
        this.isLoading = true;
        // debugger;
        const signUpSignInFlowRequest: PopupRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            prompt: PromptValue.LOGIN, // force user to reauthenticate with their new password
            scopes: [],
            redirectUri: environment.appUrl,
        };

        this.login(signUpSignInFlowRequest);
    }

    login(userFlowRequest?: RedirectRequest | PopupRequest) {
        if (this.msalGuardConfig.authRequest) {
            this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest);
        } else {
            this.msalService.loginRedirect(userFlowRequest);
        }
    }
    // ngAfterViewChecked(): void {
    //     if (!this.isSignInUser()) {
    //         setTimeout(() => {
    //             this.azureLogin();  // Call Azure login after view is updated
    //         }, 0); // Immediate timeout
    //     }
    // }
}
